/**
 * Get the pixel ratio according to the window width. Widths based on Bootsrap definitions
 */
export const getMultiplierByPixel = () => {
  const currentWidth = window.innerWidth;
  if (currentWidth >= 1200) return 1.5;
  else if (currentWidth >= 900) return 1.6;
  else if (currentWidth >= 768) return 1.7;
  // splited into one column..
  else if (currentWidth >= 576) return 1.49;
  // because the width of the bar was resized again (>)..
  else if (currentWidth >= 450) return 1.61;
  // to support the mobile ratio
  else return 1.75;
};

/**
 * Find the closest parent by its class
 * @param {*} el
 * @param {*} className
 */
export const findParentNodeByClass = (el, className) => {
  className = className.toLowerCase();
  // while the element has a parent
  while (el && el.parentNode) {
    // define the next parent in the node
    el = el.parentNode;
    // the current element contains a class
    if (el.classList && el.classList.contains(className.toLowerCase())) {
      return el;
    }
  }
  return null;
};

/**
 * Find the right position to be placing the tooltip based on its scope (div)
 * and where this scope is horizontally positioned
 * @param {*} divScope A Ref of the div where this tooltip is placed
 * @param {*} tooltip The data which contains definitions regard `width` and `x` values
 */
export const getXrayTooltipPosition = (divScope, tooltip) => {
  let position = 0;
  const halfWindowWidth = window.innerWidth / 2;
  if (divScope && tooltip.width) {
    position =
      tooltip.x + tooltip.width < halfWindowWidth &&
      divScope.getBoundingClientRect().x < halfWindowWidth
        ? // we can't define a fixed value because tooltip.width VALUE is always an integer (while it shouldn't)
          // and doesn't persist the right width so a ratio need to be used to get it well positioned
          -tooltip.width * getMultiplierByPixel()
        : 215;

    return position;
  } else {
    position = tooltip.x < halfWindowWidth - 210 ? -20 : 215;
    return position;
  }
};

/**
 * Close the tooltips from other widgets
 * @param {*} classNames String or Array of classeNames
 */
export const closeAllTooltips = (classNames) => {
  const classNameList = Array.isArray(classNames)
    ? [...classNames]
    : [classNames];
  classNameList.forEach((className) => {
    const listButtons = document.getElementsByClassName(className);
    for (let button of listButtons) button.click();
  });
};
